﻿import { writable, get } from 'svelte/store';

const myselfLabels = {
    doYou: "Do you",
    areYou: "Are you",
    haveYou: "Have you",
    wouldYou: "Would you",
    isYour: "Is your",
    isYourLower: "is your",
    you: "you",
    your: "your",
    they: "you",
    their: "your",
}

const textStore = () => {
    let store = writable(myselfLabels);

    function switchText(registrationType, firstName, surname) {
        if (registrationType === "ENQGEN001A02") {
            store.set({
                doYou: `Does ${firstName} ${surname}`,
                areYou: `Is ${firstName} ${surname}`,
                haveYou: `Has ${firstName} ${surname}`,
                wouldYou: `Would ${firstName} ${surname}`,
                isYour: `Is ${firstName} ${surname}'s`,
                isYourLower: `is ${firstName} ${surname}'s`,
                you: `${firstName} ${surname}`,
                your: `${firstName} ${surname}'s`,
                they: "they",
                their: "their",
            });
        } else {
            store.set(myselfLabels);
        }
    }

    return {
        ...store,
        switchText,
    };
}

export default textStore();
